import { Editor } from '@tinymce/tinymce-react';
import React, { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Loader } from 'rsuite';

// components
import FormLabel from './FormLabel';
import HookFormInput from './HookFormInput';
// styles
import styles from './HookFormRichText.module.less';

const HookFormRichText = ({
  name,
  defaultValue = '',
  required = false,
  label = '',
  disabled = false,
  largeLabel = false,
  subLabel = '',
}) => {
  const { setValue, formState: { errors } } = useFormContext();
  const error = errors?.[name];
  const [editorIsLoading, setEditorIsLoading] = useState(true);
  const editorRef = useRef(null);

  return (
    <section
      className={`${styles.vpHookFormRichTextContainer}`}
    >
      {editorIsLoading &&
        <section className={styles.vpLoaderContainer}>
          <Loader size="md" />
        </section>
      }
      <FormLabel largeLabel={largeLabel}>{label}</FormLabel>
      <Editor
        disabled={disabled}
        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
        onInit={(evt, editor) => {
          editorRef.current = editor;
          setEditorIsLoading(false);
        }}
        onBlur={e => {
          setValue(
            name,
            editorRef.current.getContent(),
          );
        }}
        initialValue={defaultValue}
        init={{
          height: 300,
          menubar: false,
          plugins: [
            'advlist autolink lists link image charmap print preview link',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
          ],
          toolbar: 'undo redo | formatselect | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright | bullist numlist outdent indent | ' +
            'removeformat | link',
          content_css: '/editor.css'
        }}
      />
      {error && <div className={styles.vpHookFormRichTextError}>{error?.message}</div>}
      {subLabel && <div className={styles.vpHookFormRichTextSubLabel}>{subLabel}</div>}
      <HookFormInput name={name} required={required} isHidden defaultValue={defaultValue} />
    </section>
  );
}

export default HookFormRichText;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/HookFormRichText.jsx